import { 
  SET_PERSONAL_INFO_DATA,
  RESET_PERSONAL_INFO_DATA
 } from "../actionTypes";

const initialState = {
  fileName: '', file: {},
  otherFirstName: '', otherLastName: '', dateOfBirth: {
    day: '', month: '', year: ''
  },
  zipCode: ''
};

const personalInfo = (state = {...initialState}, action) => {
  switch (action.type) {
    case SET_PERSONAL_INFO_DATA: {
      return {...state, ...action.payload};
    }
    case RESET_PERSONAL_INFO_DATA: {
      return {...initialState};
    }
    default: {
      return state;
    }
  }
};

export default personalInfo;